namespace TabAurous.HR {
    export namespace IncomeTaxSlabDetailsService {
        export const baseUrl = 'HR/IncomeTaxSlabDetails';

        export declare function Create(request: Serenity.SaveRequest<IncomeTaxSlabDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IncomeTaxSlabDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IncomeTaxSlabDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IncomeTaxSlabDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "HR/IncomeTaxSlabDetails/Create",
            Update = "HR/IncomeTaxSlabDetails/Update",
            Delete = "HR/IncomeTaxSlabDetails/Delete",
            Retrieve = "HR/IncomeTaxSlabDetails/Retrieve",
            List = "HR/IncomeTaxSlabDetails/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IncomeTaxSlabDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
